import React from 'react';
import imageIcon from '../../../images/hotspots/HotspotIcons_Image.png';
import panoIcon from '../../../images/hotspots/HotspotIcons_Panorama.png';
import textIcon from '../../../images/hotspots/HotspotIcons_Text.png';
import closeIcon from '../../../images/hotspots/HotspotIcons_Close.png';
import linkIcon from '../../../images/hotspots/HotspotIcons_Link.png';
import videoIcon from '../../../images/hotspots/HotspotIcons_Video.png';
import audioIcon from '../../../images/hotspots/HotspotIcons_Audio.png';
import highlightIcon from '../../../images/hotspots/PNG_Light/HotspotIcons_Highlight.png';
import embedIcon from '../../../images/hotspots/PNG_Light/HotspotIcons_Embed.png';
import upArrowIcon from '../../../images/hotspots/HotspotIcons_Arrow_Up.png';
import glowDark from '../../../images/hotspots/glow-dark.png';

import imageIconBlack from '../../../images/hotspots/HotspotIcons_Image-Black.png';
import panoIconBlack from '../../../images/hotspots/HotspotIcons_Panorama-Black.png';
import textIconBlack from '../../../images/hotspots/HotspotIcons_Text-Black.png';
import closeIconBlack from '../../../images/hotspots/HotspotIcons_Close-Black.png';
import linkIconBlack from '../../../images/hotspots/HotspotIcons_Link-Black.png';
import videoIconBlack from '../../../images/hotspots/HotspotIcons_Video-Black.png';
import audioIconBlack from '../../../images/hotspots/HotspotIcons_Audio-Black.png';
import highlightIconBlack from '../../../images/hotspots/PNG_Black/HotspotIcons_Highlight-black.png';
import embedIconBlack from '../../../images/hotspots/PNG_Black/HotspotIcons_Embed-Black.png';
import upArrowIconBlack from '../../../images/hotspots/HotspotIcons_Arrow_Up-Black.png';
import glowLight from '../../../images/hotspots/glow.png';
import outlineIcon from '../../../images/hotspots/outline.png';

import pauseIcon from '../../../images/hotspots/pause.png';
import playIcon from '../../../images/hotspots/play_arrow.png';
import volumeOffIcon from '../../../images/hotspots/volume_off.png';
import volumeUpIcon from '../../../images/hotspots/volume_up.png';
import descriptionIcon from '../../../images/hotspots/description.png';
import descriptionIconWhite from '../../../images/hotspots/description-white.png';
import pauseIconWhite from '../../../images/hotspots/pause-white.png';
import playIconWhite from '../../../images/hotspots/play_arrow-white.png';
import volumeOffIconWhite from '../../../images/hotspots/volume_off-white.png';
import volumeUpIconWhite from '../../../images/hotspots/volume_up-white.png';

import newHotspotIcon from '../../../images/hotspots/HotspotIcons_New_Hotspot.png';
import newHotspotIconBlack from '../../../images/hotspots/HotspotIcons_New_Hotspot-Black.png';
import { buildCloudinaryLink } from 'utils/cloudinary';

const HotspotAssets = ({ assets, handleAssetLoaded, hotspotIcons = {} }) => {
  const customIconSources = Object.keys(hotspotIcons).reduce(
    (acc = {}, key) => {
      const icon = hotspotIcons[key];
      if (icon) {
        acc[key] = buildCloudinaryLink({ path: icon.path });
      }
      return acc;
    },
    {}
  );

  const renderAssets = assets => {
    return (
      Object.keys(assets)[0] &&
      Object.values(assets).map(({ id, key, src, alt }, i) => {
        return (
          <img
            key={key + i}
            id={id}
            src={src}
            alt={alt}
            onLoad={() => handleAssetLoaded(id)}
            crossOrigin="anonymous"
          ></img>
        );
      })
    );
  };

  const customImageIcon = customIconSources['image'];
  const customPanoIcon = customIconSources['pano'];
  const customAudioIcon = customIconSources['audio'];
  const customLinkIcon = customIconSources['link'];
  const customTourStopIcon = customIconSources['stop'];
  const customTextIcon = customIconSources['text'];
  const customVideoIcon = customIconSources['video'];
  const customEmbedIcon = customIconSources['embed'];
  const customHighlightIcon = customIconSources['highlight'];

  return (
    <a-assets>
      {renderAssets(assets)}
      <img
        src={customTextIcon || textIcon}
        id="hotspot__text-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customTextIcon || textIconBlack}
        id="hotspot__text-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customImageIcon || imageIcon}
        id="hotspot__image-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customImageIcon || imageIconBlack}
        id="hotspot__image-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customPanoIcon || panoIcon}
        id="hotspot__pano-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customPanoIcon || panoIconBlack}
        id="hotspot__pano-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customLinkIcon || linkIcon}
        id="hotspot__link-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customLinkIcon || linkIconBlack}
        id="hotspot__link-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customVideoIcon || videoIcon}
        id="hotspot__video-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customVideoIcon || videoIconBlack}
        id="hotspot__video-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customAudioIcon || audioIcon}
        id="hotspot__audio-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customAudioIcon || audioIconBlack}
        id="hotspot__audio-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customTourStopIcon || upArrowIcon}
        id="hotspot__up-arrow-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customTourStopIcon || upArrowIconBlack}
        id="hotspot__up-arrow-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={glowDark}
        id="hotspot__glow-dark"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={newHotspotIcon}
        id="hotspot__new-hotspot-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={newHotspotIconBlack}
        id="hotspot__new-hotspot-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={closeIcon}
        id="hotspot__close-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={closeIconBlack}
        id="hotspot__close-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img src={glowLight} id="hotspot__glow" alt="" crossOrigin="anonymous" />
      <img
        src={outlineIcon}
        id="hotspot__outline"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={playIcon}
        id="hotspot__play-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={pauseIcon}
        id="hotspot__pause-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={volumeUpIcon}
        id="hotspot__volume-on-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={volumeOffIcon}
        id="hotspot__volume-off-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={descriptionIcon}
        id="hotspot__description-icon-black"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={customEmbedIcon || embedIconBlack}
        id="hotspot__embed-icon-black"
        crossOrigin="anonymous"
        alt=""
      />
      <img
        src={customEmbedIcon || embedIcon}
        id="hotspot__embed-icon"
        crossOrigin="anonymous"
        alt=""
      />
      <img
        src={customHighlightIcon || highlightIcon}
        id="hotspot__highlight-icon"
        crossOrigin="anonymous"
        alt=""
      />
      <img
        src={customHighlightIcon || highlightIconBlack}
        id="hotspot__highlight-icon-black"
        crossOrigin="anonymous"
        alt=""
      />
      <img
        src={playIconWhite}
        id="hotspot__play-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={pauseIconWhite}
        id="hotspot__pause-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={volumeUpIconWhite}
        id="hotspot__volume-on-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={volumeOffIconWhite}
        id="hotspot__volume-off-icon"
        alt=""
        crossOrigin="anonymous"
      />
      <img
        src={descriptionIconWhite}
        id="hotspot__description-icon"
        alt=""
        crossOrigin="anonymous"
      />
    </a-assets>
  );
};

export default HotspotAssets;
